import cn from 'classnames';

import ActionIcon from 'components/BaseHelpers/ActionIcon';

import { PageSearchResults } from '../../../../../types/components';

import styles from './Typeahead.module.scss';

export type TypeaheadProps = {
  data?: PageSearchResults;
  className?: string;
};

const Typeahead = ({ data, className }: TypeaheadProps) => {
  if (!data || !data.results || data.results.length <= 0) {
    return null;
  }
  return (
    <nav className={cn(styles.main, className)}>
      <h2 className={styles.label}>Related searches</h2>
      <ul className={styles.list}>
        {data.results.map(({ title, path }) => {
          return (
            <li className={styles.item} key={path}>
              <a href={path} className={styles.link}>
                <h3 className={styles.title}>{title}</h3>
                <ActionIcon className={styles.icon} />
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Typeahead;
